<template>
  <div>
    <v-dialog v-model="pDialog" persistent max-width="600" scrollable>
      <v-card>
        <v-toolbar dark class="datModalTitleContainer">
          <v-toolbar-title>
            Estado del albarán {{ pEstadosPelikane[0] != null ? pEstadosPelikane[0].albaran : '' }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="fCerrarModal()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container fluid mb-5>
            <v-layout row wrap class="px-2">
              <v-flex xs12 mx-auto>
                <ShpTimeline :pColor="'#001d39'" :pBultos="pBultosPelikane" :pItems="pEstadosPelikane"
                  :pUrlTracking="pUrlTracking" :pCodTracking="pCodTracking"></ShpTimeline>
              </v-flex>
            </v-layout>
            <p class="boldTitleFailTextOnModal mt-2 text-xs-justify" v-if="pError.code && pError.message">
              {{ $t("errorMssgTracking")}}
            </p>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ShpTimeline from '@/components/Pelikane/ShpTimeline'

export default {
  name: 'ShpStates',
  components: {
    ShpTimeline
  },
  props: {
    pBultosPelikane: {
      type: Array,
      required: false,
      default: []
    },
    pEstadosPelikane: {
      type: Array,
      required: false,
      default: []
    },
    pUrlTracking: {
      type: String,
      required: false,
      default: ''
    },
    pCodTracking: {
      type: Object,
      required: false,
      default: {}
    },
    pError: {
      type: Object,
      required: false,
      default: {}
    },
    pDialog: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      estadoAlbaran: true,
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false
        }
      ]
    }
  },
  watch: {
  },
  created() {

  },
  beforeDestroy() {
  },
  mounted() {
  },
  methods: {
    fCerrarModal() {
      this.$emit('cerrar')
    }

  }
}
</script>


// WEBPACK FOOTER //
// src/components/Pelikane/ShpStates.vue